import { Card, Typography } from "antd";
import { useTranslation } from "react-i18next";
import RomeLogo from "../../assets/RomeOnlineBlue.png";
import ImEXOnlineLogo from "../../assets/logo192.png";
import InstanceRenderManager from "../../utils/instanceRenderMgr";
import "./auth-shell.styles.scss";

/**
 * Provides the shared ESDP-inspired presentation used by sign-in, recovery, and MFA screens.
 *
 * @param {Object} props Authentication shell properties.
 * @param {React.ReactNode} props.children Screen-specific controls and content.
 * @param {React.ReactNode} [props.icon] Optional security icon that replaces the tenant logo.
 * @param {string} props.subtitle Supporting context rendered beneath the heading.
 * @param {string} props.title Primary screen heading.
 * @param {boolean} [props.wide=false] Whether the card should use the wider MFA layout.
 * @returns {React.ReactElement} Responsive authentication page shell.
 */
export default function AuthShell({ children, icon, subtitle, title, wide = false }) {
  const { t } = useTranslation();
  const appName = InstanceRenderManager({
    imex: t("titles.imexonline"),
    rome: t("titles.romeonline")
  });
  const logo = InstanceRenderManager({ imex: ImEXOnlineLogo, rome: RomeLogo });

  return (
    <main className="auth-shell">
      <Card className={`auth-shell__card${wide ? " auth-shell__card--wide" : ""}`}>
        <header className="auth-shell__header">
          <div className={`auth-shell__mark${icon ? " auth-shell__mark--icon" : ""}`} aria-hidden="true">
            {icon || <img src={logo} alt="" />}
          </div>
          <Typography.Title level={2}>{title || appName}</Typography.Title>
          <Typography.Text type="secondary">{subtitle}</Typography.Text>
        </header>
        <div className="auth-shell__content">{children}</div>
      </Card>
    </main>
  );
}
